import { createFileRoute } from '@tanstack/react-router'
import { Header } from '@/components/layout/header'
import { Main } from '@/components/layout/main'
import { TopNav } from '@/components/layout/top-nav'
import { ProfileDropdown } from '@/components/profile-dropdown'
import { Search as SearchComponent } from '@/components/search'
import { ThemeSwitch } from '@/components/theme-switch'
import KariyerModule from '@/modules/kariyer'

const topNav = [
  { title: 'Anasayfa', href: '/', isActive: false },
]

function IsIlanlariPage() {
  return (
    <>
      <Header>
        <TopNav links={topNav} />
        <div className="ml-auto flex items-center gap-2">
          <SearchComponent />
          <ThemeSwitch />
          <ProfileDropdown />
        </div>
      </Header>

      <Main>
        <KariyerModule />
      </Main>
    </>
  )
}

export const Route = createFileRoute('/_authenticated/is-ilanlari/')({
  component: IsIlanlariPage,
})

